import { api } from "@/lib/apiClient";

let live = null;
let loaded = null;

// Share/invite links use xcelio.app once it's verified live; until then, the address he's on.
export function loadShareOrigin() {
  loaded = loaded || api.get("/public/site-origin").then((r) => { live = r.data.origin || null; return live; }).catch(() => null);
  return loaded;
}

export const shareOrigin = () => live || window.location.origin;
